import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import packages from './package'
import packages_stu from './package_stu'
import * as echarts from 'echarts'
import mixin from './mixin'
import request from './http'
import getStaticFile from '@/http/static'
import { VueJsonp } from 'vue-jsonp'
import './permission.js'
import './china.js'
import VideoPlayer from 'vue-video-player';
require('vue-video-player/node_modules/video.js/dist/video-js.css')
require('vue-video-player/src/custom-theme.css')
import '@/assets/style/icon-font/iconfont.css'
import '@/assets/style/common.css'
import '@/assets/style/ots-eui.css'
import {VueCropper} from 'vue-cropper'

// Vant
import Vant from 'vant'
import 'vant/lib/index.css';

// PDF
import htmlToPdf from "./assets/js/htmlToPdf"


// Data_V
import 'amfe-flexible';
import '@/assets/text/text.css';
import VueFullscreen from 'vue-fullscreen'

Vue.config.productionTip = false
Vue.prototype.$event = new Vue()
Vue.prototype.$api = request
Vue.prototype.$getStaticFile = getStaticFile
Vue.prototype.$echarts = echarts
Vue.use(VueFullscreen)
Vue.use(ElementUI)
Vue.use(VueCropper)
Vue.use(VideoPlayer)
Vue.use(packages)
Vue.use(VueJsonp)
Vue.use(packages_stu)
Vue.use(Vant)
Vue.use(htmlToPdf)
Vue.mixin(mixin)
new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')